import { Product, ProductDetailsResponse } from "../types/products";

/**
 * Maps a search Product to a ProductDetailsResponse for cart operations.
 * This ensures consistent data structure and proper field mapping.
 */
export function mapSearchProductToCartProduct(
  product: Product,
  retailer: string
): ProductDetailsResponse {
  return {
    product_id: product.product_id,
    title: product.title,
    price: product.price,
    brand: product.brand,
    retailer: retailer.toLowerCase(), // Normalize retailer casing
    stars: product.stars,
    review_count: product.num_reviews ?? undefined,
    image: product.image,
    main_image: product.image,
    ship_price: product.ship_price ?? 0,
    cargo_price: 0, // Will be calculated in checkout using shipping cost
    free_shipping: product.free_shipping ?? false,
    // Set minimal required fields for cart operations
    categories: [],
    images: product.image ? [product.image] : [],
  };
}
